module.exports = __webpack_public_path__ + "static/media/halo-clean.95bf0686.svg";